import { css } from '@emotion/react'
import mediaQueries from '../../layout/media-queries'

const COLUMNS_COUNT = 12
const COLUMN_WIDTH = 100 / COLUMNS_COUNT
const GUTTER = '30px'
const GUTTER_SMALL = '16px'

const SIZES = {
  xs: 'xs',
  s: 's',
  m: 'm',
  l: 'l',
}

const generateAllColsStyle = (count, size) => {
  const columns = [...new Array(count)].map((_, i) => i + 1)

  return columns.reduce((acc, columnNumber, i) => {
    acc =
      i > 0
        ? `${acc}, .col-${size}-${columnNumber}`
        : `.col-${size}, .col-${size}-${columnNumber}`
    return acc
  }, '')
}

const generateColWidths = (count, size) => {
  const columns = [...new Array(count)].map((_, i) => i + 1)

  return columns
    .map((columnNumber) => {
      const colWidth = COLUMN_WIDTH * columnNumber

      return `.col-${size}-${columnNumber} {
        flex-basis: ${colWidth}%;
        max-width: ${colWidth}%;
     }`
    })
    .join(' ')
}

const generateAligningClasses = (size) => `
  .start-${size} {
    justify-content: flex-start;
    text-align: start;
  }

  .center-${size} {
    justify-content: center;
    text-align: center;
  }

  .end-${size} {
    justify-content: flex-end;
    text-align: end;
  }

  .top-${size} {
    align-items: flex-start;
  }

  .middle-${size} {
    align-items: center;
  }

  .bottom-${size} {
    align-items: flex-end;
  }

  .around-${size} {
    justify-content: space-around;
  }

  .between-${size} {
    justify-content: space-between;
  }
`

const generateCol = (columnsCount, size) => `
 ${generateAllColsStyle(columnsCount, size)} {
    flex: 0 0 auto;
    padding-right: ${GUTTER_SMALL};
    padding-left: ${GUTTER_SMALL};

    ${mediaQueries.xlargeScreen()} {
      padding-right: ${GUTTER};
      padding-left: ${GUTTER};
    }
  }

  ${generateColWidths(columnsCount, size)}

  ${generateAligningClasses(size)}
`

export const layoutCss = css`
  .container {
    margin-right: auto;
    margin-left: auto;
  }

  .row {
    display: flex;
    flex: 0 1 auto;
    flex-direction: row;
    flex-wrap: wrap;
    margin-right: -${GUTTER_SMALL};
    margin-left: -${GUTTER_SMALL};

    ${mediaQueries.xlargeScreen()} {
      margin-right: -${GUTTER};
      margin-left: -${GUTTER};
    }
  }

  .row.reverse {
    flex-direction: row-reverse;
  }

  .col {
    display: flex;
    flex: 0 0 auto;
    padding-right: ${GUTTER_SMALL};
    padding-left: ${GUTTER_SMALL};

    ${mediaQueries.xlargeScreen()} {
      padding-right: ${GUTTER};
      padding-left: ${GUTTER};
    }
  }

  .col.reverse {
    flex-direction: column-reverse;
  }

  // XS
  ${generateCol(COLUMNS_COUNT, SIZES.xs)}

  // S
  ${mediaQueries.smallScreen()} {
    ${generateCol(COLUMNS_COUNT, SIZES.s)}
  }

  // M
  ${mediaQueries.mediumScreen()} {
    ${generateCol(COLUMNS_COUNT, SIZES.m)}
  }

  // L
  ${mediaQueries.largeScreen()} {
    ${generateCol(COLUMNS_COUNT, SIZES.l)}
  }
`
